import { Link } from 'react-router-dom';
import { useUserSidebar } from '../../hooks/useUserSidebar';
import { ORBCON_REPORT_NAV_LABEL, ORBCON_REPORT_PATH } from '../../content/orbconReport';

export default function Footer() {
  const { compactChrome } = useUserSidebar();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className={`grid grid-cols-1 gap-8 items-start ${compactChrome ? '' : 'md:grid-cols-4'}`}>
          {/* Organization Info */}
          <div className={`col-span-1 ${compactChrome ? '' : 'md:col-span-2'}`}>
            <Link to="/" className="inline-block -mt-4">
              <img src="/images/ORBCoN-EN-Colour.png" alt="ORBCoN" className="h-48" />
            </Link>
            <p className="text-gray-600 text-sm mt-4">
              Resources for Transfusion Medicine Professionals
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Explore</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/resources" className="text-sm text-gray-600 hover:text-primary">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/references/glossary" className="text-sm text-gray-600 hover:text-primary">
                  Glossary
                </Link>
              </li>
              <li>
                <Link to={ORBCON_REPORT_PATH} className="text-sm text-gray-600 hover:text-primary">
                  {ORBCON_REPORT_NAV_LABEL}
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-sm text-gray-600 hover:text-primary">
                  Events
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">ORBCoN</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-gray-600 hover:text-primary">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-primary">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/order-resources" className="text-sm text-gray-600 hover:text-primary">
                  Order Resources
                </Link>
              </li>
              <li>
                <Link to="/useful-links" className="text-sm text-gray-600 hover:text-primary">
                  Useful Links
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm text-gray-600 hover:text-primary">
                  Careers
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-2 text-sm text-gray-600">
          <p>© {new Date().getFullYear()} ORBCoN. All rights reserved.</p>
          <Link to="/privacy" className="hover:text-primary">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-primary">
            Terms of Use
          </Link>
        </div>
      </div>
    </footer>
  );
}

